import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import ko from 'knockout';
import _ from 'underscore';
import Promise from 'bluebird';
import config from '@bingads-webui-component-legacy/config/index';
import ViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adEditor';
import editorTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adEditor.pug';
import improveMMAAdEditor from '@bingads-webui-campaign-legacy/crud-ad/template/improveMMAAdEditor.pug';
import TextAdView from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/textAd';
import AppInstallAdView from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/appInstallAd';
import DynamicSearchAdView from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/dynamicSearchAd';
import ProductAdView from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/productAd';
import ExpandedTextAdView from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/expandedTextAd';
import ResponsiveAdView from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/ResponsiveAd';
import ResponsiveSearchAdView from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/responsiveSearchAd';
import ResponsiveSearchAdEditor from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/ResponsiveSearchAdEditor';
import XandrVideoAd from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/xandrVideoAd';
import XandrDisplayAd from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/xandrDisplayAd';
import DisplayPlusDisplayAd from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/displayPlusDisplayAd';
import DisplayPlusNativeAd from '@bingads-webui-campaign-legacy/crud-ad/view/adsEditor/displayPlusNativeAd';
import * as schemaMapper from '@bingads-webui-campaign-legacy/crud-ad/schemaMapper';
import { lengthExceededErrorCodes } from '@bingads-webui-campaign-legacy/crud-ad/lengthExceededErrorCodes';
import { getAppealableErrors, getODataErrors, getBulkApiErrors } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import uuid from '@bingads-webui-component-legacy/uuid/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import EditorialAppealView from '@bingads-webui-component-legacy/editorial-appeal/view/index';
import legacyInstru from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import { getPath1AndPath2 } from '@bingads-webui-campaign-legacy/crud-ad/service/displayUrl';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import { testUurl, uurlLevels } from '@bingads-webui-component-legacy/upgraded-url/service/testUurl';
import { getUtcTime } from '@bingads-webui-universal/primitive-utilities';
import { AdFormatOption, AdFormat } from '@bingads-webui-campaign-react/display-plus-native-ads';
import { setClarityTag } from '@bingads-webui-universal/clarity';
import { isXandrDisplayAdsCampaign, isXandrVideoAdsCampaign, isAudienceNativeAdsCampaign, isAudienceCampaign } from '@bingads-webui-campaign-react/constants';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

const permissions = config.get('Permissions') || {};

const adTypeMapper = {
  Text: TextAdView,
  AppInstall: AppInstallAdView,
  DynamicSearch: DynamicSearchAdView,
  Product: ProductAdView,
  ExpandedText: ExpandedTextAdView,
  Responsive: ResponsiveAdView,
};

const adTypeSchema = {
  Text: 'TextAd',
  AppInstall: 'AppInstallAd',
  DynamicSearch: 'DynamicSearchAd',
  Product: 'ProductAd',
  ExpandedText: 'ExpandedTextAd',
  ResponsiveSearch: 'ResponsiveSearchAd',
  Responsive: 'ResponsiveAd',
};

const adTypeEnum = {
  text: 'Text',
  dynamicSearch: 'DynamicSearch',
  appInstall: 'AppInstall',
  product: 'Product',
  expandedText: 'ExpandedText',
  responsive: 'Responsive',
  responsiveSearch: 'ResponsiveSearch',
};

export default class AdEditor extends Backbone.View {
  initialize({
    newI18n,
    model = null,
    externalCachedImageExtensionChanges = null,
    onCachedImageExtensionChanged,
    accountId = null,
    campaignId = null,
    adGroupId = null,
    adGroupType = null,
    campaignType = null,
    campaignSubType = null,
    biddingStrategyType = '',
    isFeedBasedCampaign = null,
    isSaveToServer = true, // whether or not saving the ad to server when user clicks save button
    showInline = false, // is current ad editor shown under ads tab, true means showing under ads tab and use OData API, false will use Bulk Upload API
    showSaveAndCreateAnother = true, // whether show button for save and create another ad
    appInstallAdsAllowed = permissions.IsUserAppInstallAdsAllowed,
    isNativeAdsEnabled = permissions.IsNativeAdsAllowed,
    isVanityUrlEnabled = permissions.IsVanityUrlEnabled,
    isSTADisabled = permissions.IsSTADisabled,
    isRSAAsDefaultTypeEnabled = permissions.IsRSAAsDefaultType,
    isResponsiveAdEnabled = permissions.IsAIMCampaignEnabled,
    isMultiMediaAdsEnabled = permissions.IsMultiMediaAdsEnabled,
    isMMAInDSAEnabled = permissions.IsMMAInDSAEnabled,
    isTraditionalChinese = false, // is current adgroup with traditional chinese
    appLookupDisabled = false,
    developerName = '',
    campaignDomain = '',
    isDynamicDescriptionEnabled = false,
    defaultLandingPageUrl = '',
    firstTextAdModel = {},
    firstExpandedTextAdModel = {},
    firstResponsiveSearchAdModel = {},
    perfMarker = null,
    isForVNext = false,
    inlineSuggestionsEnabled = false,
    showLightbulb = false,
    isRecommendation = false,
    adsCountMap = {},
    activityLogger,
    isImpressionTrackingUrlsEnabled = permissions.IsImpressionTrackingUrlsEnabled,
    isOpenCreatePanel = false, // whether the editor is opened from the link in delivery status column
    hasWebsiteImageOptedInObservable, // pass to responsive-ad-editor to update enable/disable ad button state for showInline scenario
    isAdgroupCreation = false,
    isImproveRSA = false,
    isImproveMMA = false,
    serverContext = {},
    preferenceService,
    loadClipchampPlayer,
  } = {}) {
    if (perfMarker) {
      this.perfMarker = perfMarker;
      this.perfMarkerRender = perfMarker.createChild('Ad_Editor_Show');
      this.perfMarkerRender.willInit();
    }
    this.isSaveToServer = isSaveToServer;
    this.newI18n = newI18n;
    this.showInline = showInline;
    this.campaignType = campaignType;
    this.campaignSubType = campaignSubType;
    this.showSaveAndCreateAnother = showSaveAndCreateAnother;
    this.editMode = !_.isEmpty(this.model) && (showInline || this.model.isSaved); //edit ad which was already saved to server
    this.activityLogger = activityLogger;
    this.isMigratingToEXTA = !_.isEmpty(this.model) && showInline && this.model.Type === adTypeEnum.text; // show migration UI only in ads tab
    this.isSTADisabled = isSTADisabled;
    this.isRSAAsDefaultTypeEnabled = isRSAAsDefaultTypeEnabled;
    this.isMultiMediaAdsEnabled = isMultiMediaAdsEnabled;
    this.isOpenCreatePanel = isOpenCreatePanel;
    this.isImproveMMA = isImproveMMA;
    this.serverContext = serverContext;
    this.isDisplayPlusNativeEdit = permissions.dynamic.DisplayPlusEdit && this.isAudienceNativeCampaign(this.campaignType, this.campaignSubType);
    this.isMultiAdFormatEnabled = permissions.dynamic && permissions.dynamic.MultiAdFormat && this.isDisplayPlusNativeEdit && !permissions.IsAmplifyEnabled;

    if (permissions.dynamic && permissions.dynamic.EnableNewResponsiveSearchAdEditor && !isRecommendation) {
      adTypeMapper.ResponsiveSearch = ResponsiveSearchAdEditor;
    } else {
      adTypeMapper.ResponsiveSearch = ResponsiveSearchAdView;
    }

    if (permissions.dynamic.XandrVideoCampaigns && isXandrVideoAdsCampaign(this.campaignSubType)) {
      adTypeMapper.Responsive = XandrVideoAd;
      this.isXandrVideoAd = true;
    } else if (permissions.dynamic.XandrDisplayAdsCampaigns && isXandrDisplayAdsCampaign(this.campaignSubType)) {
      if (permissions.dynamic.DisplayPlusCopilotAssetGeneration) {
        adTypeMapper.Responsive = DisplayPlusDisplayAd;
      } else {
        adTypeMapper.Responsive = XandrDisplayAd;
      }
    } else if (this.isDisplayPlusNativeEdit) {
      setClarityTag({
        IsDisplayPlusAudienceNative: true,
        CampaignSubType: this.campaignSubType,
      });

      adTypeMapper.Responsive = DisplayPlusNativeAd;

      if (this.isMultiAdFormatEnabled && this.isDisplayAdUnderNativeCampaign(model)) {
        adTypeMapper.Responsive = DisplayPlusDisplayAd;
      } else if (this.isMultiAdFormatEnabled && this.isVideoAdUnderNativeCampaign(model)) {
        adTypeMapper.Responsive = XandrVideoAd;
      }
    } else {
      adTypeMapper.Responsive = ResponsiveAdView;
    }

    let defaultSelectedAdFormat = AdFormat.Native;

    if (this.isMultiAdFormatEnabled && this.isMultiAdFormatDisplayAd) {
      defaultSelectedAdFormat = AdFormat.Display;
    } else if (this.isMultiAdFormatEnabled && this.isMultiAdFormatVideoAd) {
      defaultSelectedAdFormat = AdFormat.Video;
    }

    this.viewModel = new ViewModel({
      model,
      campaignId,
      adGroupId,
      adGroupType,
      campaignType,
      campaignSubType,
      showInline,
      appInstallAdsAllowed,
      campaignDomain,
      isDynamicDescriptionEnabled,
      isFeedBasedCampaign,
      isMigratingToEXTA: this.isMigratingToEXTA,
      isSTADisabled,
      isRSAAsDefaultTypeEnabled,
      isResponsiveAdEnabled,
      isMMAInDSAEnabled,
      isForVNext,
      adsCountMap,
      perfMarker,
      isAdgroupCreation,
      selectedAdFormat: defaultSelectedAdFormat,
    });

    if (showInline) {
      this.hasWebsiteImageOptedInObservable = hasWebsiteImageOptedInObservable;
    } else {
      this.hasWebsiteImageOptedInObservable = this.viewModel.hasWebsiteImageOptedInObservable;
    }

    let scenario = instrumentation[`ad${this.editMode ? 'Edit' : 'Creation'}${this.viewModel.Type()}`].create();// eslint-disable-line

    this.activity = scenario[`ad${this.editMode ? 'Edit' : 'Creation'}`].create();
    this.activity.start();

    this.applyActivity = instrumentation.inContextRepairRecommendation.create().applyDeliveryStatus.create();
    this.adTypeViews = {};

    this.firstModelMap = {};
    this.firstModelMap[adTypeEnum.text] = firstTextAdModel;
    this.firstModelMap[adTypeEnum.expandedText] = firstExpandedTextAdModel;
    this.firstModelMap[adTypeEnum.responsiveSearch] = firstResponsiveSearchAdModel;

    _.each(this.viewModel.availableAdTypes, (type) => {
      let fillModel = model;

      if (this.isMigratingToEXTA && type === adTypeEnum.expandedText) {
        fillModel = this.mapSTAToEXTA(this.model);
      } else if (_.contains([
        adTypeEnum.text,
        adTypeEnum.expandedText,
        adTypeEnum.responsiveSearch,
      ], type) && _.isEmpty(this.model) && showInline) {
        fillModel = this.firstModelMap[type];

        // Clean NativePreference flag for RSA
        if (adTypeEnum.responsiveSearch === type) {
          fillModel = _.omit(fillModel, 'NativePreference');
        }
      }

      this.adViewOption = {
        campaignId,
        adGroupId,
        biddingStrategyType,
        permissions,
        perfMarker,
        timeZone: config.get('AccountTimeZone'),
        instrumentation,
        newI18n,
        editMode: this.editMode,
        isNativeAdsEnabled,
        isVanityUrlEnabled,
        showInline,
        model: fillModel,
        appLookupDisabled,
        developerName,
        isTraditionalChinese,
        scope: this.viewModel.scope,
        defaultLandingPageUrl,
        isForVNext,
        inlineSuggestionsEnabled,
        showLightbulb,
        activityLogger: this.activityLogger || this.activity,
        isMobileUrlEnabled: campaignSubType !== 'ShoppingSmartAds' && campaignSubType !== 12,
        isImpressionTrackingUrlsEnabled,
        isVideo: campaignSubType === 'AudienceVideoAds' || isXandrVideoAdsCampaign(campaignSubType),
        isMultimediaAd: type === adTypeEnum.responsive && (campaignType === 'Default' || campaignType === 1),
        isPlaceholderMMA: type === adTypeEnum.responsive && this.viewModel.isDynamicAdGroupAdCreation(),
        hasWebsiteImageOptedInObservable: this.hasWebsiteImageOptedInObservable,
        isRecommendation,
        campaignDomain,
        logActivity: this.logActivity.bind(this),
        edm: edmCampaign,
        externalCachedImageExtensionChanges,
        onCachedImageExtensionChanged,
        showImgExtWithoutAdGroupID: this.isSaveToServer === false && isAdgroupCreation === true && adGroupType === 'SearchStandard',
        jsdata,
        isImproveRSA,
        accountId,
        isImproveMMA,
        serverContext,
        preferenceService,
        triggerCancel: this.cancel.bind(this),
        triggerClose: this.triggerClose.bind(this),
        handleSave: this.handleSave.bind(this),
        isMultiAdFormatAd: this.isMultiAdFormatEnabled && (this.isDisplayAdUnderNativeCampaign(model) || this.isVideoAdUnderNativeCampaign(model)),
        loadClipchampPlayer,
      };

      this.adTypeViews[type] = new adTypeMapper[type](this.adViewOption);

      const testUurlAdTypes = [adTypeEnum.expandedText, adTypeEnum.responsiveSearch, adTypeEnum.appInstall];

      if (_.contains(testUurlAdTypes, type)) {
        this.adTypeViews[type].on('testUurl', (fn, originalView) => {
          if (!this.validate(this._type)) {
            fn.call(originalView, null); // to stop the loading spinner
            return;
          }

          originalView.isInline = false;
          originalView.level = uurlLevels.Ad;
          const params = this.adTypeViews[type].toObject();
          const context = {
            customerId: _.result(config.get('CurrentCustomer'), 'Id'),
            userId: _.result(config.get('CurrentUser'), 'Id'),
            accountId: _.result(config.get('CurrentAccount'), 'Id'),
            campaignId: _.result(config.get('CurrentCampaign'), 'Id') || this.viewModel.scope().campaignId || 0,
            adGroupId: _.result(config.get('CurrentAdGroup'), 'Id') || this.viewModel.scope().adGroupId || 0,
            entityId: this.model && this.model.Id && _.isNumber(this.model.Id) ? this.model.Id : '',
          };
          const options = {
            apiInLog: 'adEditor/uurlTest',
          };

          testUurl(fn, originalView, params, context, options);
        });
      }
    });

    this.prevScope = {};

    this.viewModel.scope.subscribe((scope) => {
      this.prevScope = scope;
    }, this, 'beforeChange');

    this.viewModel.scope.subscribe((scope) => {
      this.isDisplayPlusNativeEdit = permissions.dynamic.DisplayPlusEdit && this.isAudienceNativeCampaign(scope.campaignType, scope.campaignSubType) && !permissions.IsAmplifyEnabled;
      this.isMultiAdFormatEnabled = permissions.dynamic && permissions.dynamic.MultiAdFormat && this.isDisplayPlusNativeEdit && !permissions.IsAmplifyEnabled;

      if (this.isDisplayPlusNativeEdit) {
        setClarityTag({
          IsDisplayPlusAudienceNative: true,
          CampaignSubType: scope.campaignSubType,
        });
      }

      const adFormat = this.viewModel.selectedAdFormat();

      _.each(this.viewModel.adTypesRegisterForLanguageChange, (adType) => {
        const viewModel = this.adTypeViews[adType].viewModel;

        if (viewModel.isTraditionalChinese) {
          viewModel.isTraditionalChinese(scope.isTraditionalChinese);
        }
      });

      if (this.viewModel.scope().adGroupId) {
        if (this._type === 'Responsive' && this.prevScope.campaignType !== scope.campaignType) {
          this.logActivity(`campaign type changed from ${this.prevScope.campaignType} to ${scope.campaignType}`);
          this.refreshResponsiveAdEditor(scope, adFormat);
        }

        if (this._type === 'Responsive' && this.prevScope.adGroupType !== scope.adGroupType) {
          this.refreshResponsiveAdEditor(scope, adFormat);
        }

        this.logActivity('ad editor rendered');
      }
    }, this);

    this.viewModel.Type.subscribe((type) => {
      this.trigger('type', type);
      const scope = this.viewModel.scope();
      const adFormat = this.viewModel.selectedAdFormat();

      if (type === 'Responsive' && campaignSubType !== 12 && campaignSubType !== 'ShoppingSmartAds') {
        this.refreshResponsiveAdEditor(scope, adFormat);
      }
      scenario = instrumentation[`ad${this.editMode ? 'Edit' : 'Creation'}${type}`].create();

      this.activity = scenario[`ad${this.editMode ? 'Edit' : 'Creation'}`].create();
      this.activity.start();
      this.logActivity(`ad type change: ${type}`);
      if (type === 'Responsive') {
        setClarityTag({ NewSearchMMAEditor: 'true' });
      }
    }, this);

    this.viewModel.selectedAdFormat.subscribe((adFormat) => {
      const scope = this.viewModel.scope();

      this.refreshResponsiveAdEditor(scope, adFormat);
    }, this);
  }

  get events() {
    return {
      'click .appEditor-save-container .save': 'save',
      'click .appEditor-save-container .cancel': 'cancel',
      'click .save-create-another': 'saveAndCreateAnother',
      'click .switchBackToSTA': 'switchBackToSTA',
      'click .switchBackToEXTA': 'switchBackToEXTA',
    };
  }

  isRSANewCopilotScenario() {
    return this._type === adTypeEnum.responsiveSearch &&
      this.adViewOption.inlineSuggestionsEnabled;
  }

  isAudienceNativeCampaign(campaignType, campaignSubType) {
    return isAudienceCampaign(campaignType) && isAudienceNativeAdsCampaign(campaignSubType);
  }

  isDisplayAdUnderNativeCampaign(model) {
    this.isMultiAdFormatDisplayAd = isAudienceNativeAdsCampaign(this.campaignSubType) && model && model.AdSubType === 'Display';
    return this.isMultiAdFormatDisplayAd;
  }

  isVideoAdUnderNativeCampaign(model) {
    this.isMultiAdFormatVideoAd = isAudienceNativeAdsCampaign(this.campaignSubType) && model && model.AdSubType === 'Video';
    return this.isMultiAdFormatVideoAd;
  }

  logActivity(message, api = 'ad editor') {
    api = `${this.activity.value} | ${this.viewModel.Type()} | campaignType: ${this.viewModel.scope().campaignType} | adGroupType: ${this.viewModel.scope().adGroupType} | ${api}`; // eslint-disable-line no-param-reassign, new-cap
    if (this.activityLogger) {
      this.activityLogger.signal(message, api);
    } else {
      legacyInstru.logMessage(
        [constants.LOGCATEGORY.SUBSTRATE],
        constants.LOGLEVEL.INFO,
        api,
        message,
      );
    }
  }

  onAdFormatChange(adFormat) {
    this.viewModel.selectedAdFormat(adFormat);
  }

  logCopilotRSAAssetSuggestionAdoption() {
    const data = this.adTypeViews.ResponsiveSearch;
    const cachedAd = data ? data.cachedAd : null;
    const cachedAdExtension = data ? data.cachedImageExtensionChanges : null;

    if (cachedAd && cachedAd.data) {
      const headlines = cachedAd.data.Headlines || [];
      const descriptions = cachedAd.data.Descriptions || [];
      const entityId = this.model ? this.model.Id : this.lastClientModelId;
      const currentAdExtension = (cachedAdExtension && cachedAdExtension.current) || [];
      const suggestedAdExtensions = _.filter(currentAdExtension, (ext) => ext.source === 'CopilotRecommendation');

      data.logAppliedSuggestionsFunc({
        headlines: headlines.map((t) => t.Asset.Text),
        descriptions: descriptions.map((t) => t.Asset.Text),
        entityId,
        suggestedAdExtensions,
      });
    }
  }

  logRSAAssetSuggestionAdoption() {
    let data = null;

    if (permissions.dynamic && permissions.dynamic.EnableNewResponsiveSearchAdEditor) {
      data = this.adTypeViews.ResponsiveSearch;
    } else if (this.model === null || !this.adTypeViews.ResponsiveSearch.adStrengthContainer) {
      return;
    } else {
      data = this.adTypeViews.ResponsiveSearch.adStrengthContainer.options.viewModel;
    }

    const message = JSON.stringify({
      Scenario: this.activity.value,
      TimeStamp: getUtcTime(),
      AcceptInfo: {
        ReturnSuggestionIds: data.returnSuggestionIds,
        ViewSuggestionIds: data.viewSuggestionIds,
        ApplySuggestionIds: data.applySuggestionIds,
        ClickViewIdeas: data.clickViewIdeas,
      },
      AdId: this.model.Id,
      Channel: 'bingadsweb[incontextrecommendation]',
      Feature: 'RSA_V2',
      Action: 'Accept',
      UserId: _.result(config.get('CurrentUser'), 'Id'),
    });

    this.logActivity(JSON.stringify(this.model), 'ad editor model when save rsa with suggestion');
    this.logActivity(message, 'rsa asset suggestion adoption');
  }

  logDeliveryStatusRecommendationAdoption() {
    const mes = { CampaignId: this.viewModel.scope().campaignId, AdGroupId: this.viewModel.scope().adGroupId, DeliveryStatusType: 'NoEligibleAds' };

    this.applyActivity.trace(JSON.stringify(mes));
  }

  refreshResponsiveAdEditor(scope, selectedAdFormat) {
    const originalResponsiveAdEditorView = this.adTypeViews.Responsive;
    const newOption = _.extend({}, this.adViewOption, {
      isMobileUrlEnabled: scope.campaignSubType !== 'ShoppingSmartAds' && scope.campaignSubType !== 12,
      isVideo: scope.campaignSubType === 'AudienceVideoAds' || isXandrVideoAdsCampaign(scope.campaignSubType),
      isMultimediaAd: scope.campaignType === 'Default' || scope.campaignType === 1,
      isPlaceholderMMA: this.viewModel.isDynamicAdGroupAdCreation(),
      hasWebsiteImageOptedInObservable: this.hasWebsiteImageOptedInObservable,
      campaignDomain: scope.campaignDomain,
      biddingStrategyType: scope.biddingStrategyType,
      jsdata,
      isMultiAdFormatAd: this.isMultiAdFormatEnabled, // Check sub type function,
    });

    originalResponsiveAdEditorView.remove();

    this.adTypeViews.Responsive = new ResponsiveAdView(newOption);

    if (isXandrVideoAdsCampaign(scope.campaignSubType)) {
      this.adTypeViews.Responsive = new XandrVideoAd(newOption);
    }

    if (isXandrDisplayAdsCampaign(scope.campaignSubType)) {
      if (permissions.dynamic.DisplayPlusCopilotAssetGeneration) {
        this.adTypeViews.Responsive = new DisplayPlusDisplayAd(newOption);
      } else {
        this.adTypeViews.Responsive = new XandrDisplayAd(newOption);
      }
    }

    if (permissions.dynamic.DisplayPlusEdit && this.isAudienceNativeCampaign(scope.campaignType, scope.campaignSubType)) {
      setClarityTag({
        IsDisplayPlusAudienceNative: true,
        CampaignSubType: scope.campaignSubType,
      });

      this.adTypeViews.Responsive = new DisplayPlusNativeAd(newOption);

      if (this.isMultiAdFormatEnabled && selectedAdFormat === AdFormat.Display) {
        this.adTypeViews.Responsive = new DisplayPlusDisplayAd(newOption);
      } else if (this.isMultiAdFormatEnabled && selectedAdFormat === AdFormat.Video) {
        this.adTypeViews.Responsive = new XandrVideoAd(newOption);
      }
    }

    this.$('[data-type=Responsive]').empty().prepend(this.adTypeViews.Responsive.render().el);

    this.renderAdFormatOption();
  }

  render() {
    if (this.perfMarkerRender) {
      this.perfMarkerRender.willRender();
    }
    if (this.isImproveMMA) {
      this.$el.html(improveMMAAdEditor({
        i18n,
        i18nGlobal,
        permissions,
        showInline: this.showInline,
        editMode: !_.isEmpty(this.model),
        isMigratingToEXTA: this.isMigratingToEXTA,
        adTypeEnum,
        isSTADisabled: this.isSTADisabled,
        showSaveAndCreateAnother: this.showSaveAndCreateAnother,
        isDisplayPlusNativeEdit: this.isDisplayPlusNativeEdit,
        isDisplayPlusDisplayAd: permissions.dynamic.DisplayPlusCopilotAssetGeneration && isXandrDisplayAdsCampaign(this.campaignSubType),
      }));
    } else {
      this.$el.html(editorTemplate({
        i18n,
        i18nGlobal,
        permissions,
        showInline: this.showInline,
        editMode: !_.isEmpty(this.model),
        isMigratingToEXTA: this.isMigratingToEXTA,
        adTypeEnum,
        isSTADisabled: this.isSTADisabled,
        showSaveAndCreateAnother: this.showSaveAndCreateAnother,
        isDisplayPlusNativeEdit: this.isDisplayPlusNativeEdit,
        isDisplayPlusDisplayAd: permissions.dynamic.DisplayPlusCopilotAssetGeneration && isXandrDisplayAdsCampaign(this.campaignSubType),
        isXandrVideoAd: this.isXandrVideoAd,
        isMultiAdFormatDisplayAd: this.isMultiAdFormatDisplayAd,
        isMultiAdFormatVideoAd: this.isMultiAdFormatVideoAd,
      }));
    }

    ko.applyBindings(this.viewModel, this.el);

    _.each(this.adTypeViews, (subView, key) => {
      subView.render();
      this.$(`[data-type=${key}]`).prepend(subView.el);
    });

    this.editorialAppeal = new EditorialAppealView();
    this.$('.editorial-appeal-panel').append(this.editorialAppeal.render().el);

    if (!_.isEmpty(this.model) && !this.model.hasError && !this.isMigratingToEXTA) {
      // In adgroup creation page, when changing from single byte market to double byte market, need do validation in case exceeding max length
      // In Sta to Exta Migration UI (which is only under ads tab), shouldn't do validate before user click save
      this.validate(this._type);
    }

    this.setErrorsIfExist();

    this.on('saving', () => {
      if (this.isRSANewCopilotScenario()) {
        this.adTypeViews[this._type].triggerSaving();
      }
    });

    this.on('canceling', () => {
      if (this.isRSANewCopilotScenario()) {
        this.adTypeViews[this._type].triggerCanceling();
      }
    });

    this.on('cancel', () => {
      if (this.isMigratingToEXTA) {
        legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'crud-ad/view/adEditor', 'extaMigration-cancel');
      }
      this.adTypeViews[this._type].trigger('cancel');
      // Trigger survey in ads page when RSA editor is cancelled
      if (this._type === adTypeEnum.responsiveSearch && window.survey && window.survey.surveyManager) {
        window.survey.surveyManager.trigger({ checkIfSurveyIsOpen: true });
      }
    });

    if (this.perfMarkerRender) {
      this.perfMarkerRender.done();
    }

    if (this.viewModel.scope().adGroupId != null) {
      this.logActivity('ad editor rendered');
    }

    this.renderAdFormatOption();

    return this;
  }

  renderAdFormatOption() {
    if (this.isMultiAdFormatEnabled) {
      ReactDOM.render(
        <AdFormatOption
          value={this.viewModel.selectedAdFormat()}
          i18n={this.newI18n}
          disabled={this.editMode}
          showHeader={false}
          onChange={this.onAdFormatChange.bind(this)}
        />,
        this.el.querySelector('.ad-format-option-container'),
      );
    }
  }

  remove() {
    if (!this.closingAfterSave) {
      this.logActivity('ad editor dismissed');
    }
    this.editorialAppeal.remove();
    _.each(this.adTypeViews, (subView) => {
      subView.remove();
    });
    super.remove();
  }

  setErrorsIfExist() {
    if (!_.isEmpty(this.model) && this.model.hasError) {
      this.handleApiErrors(this.model.errors);
    }
  }

  save() {
    this.logActivity('ad editor click save');
    this.trigger('saving');

    if (this.perfMarker) {
      this.perfMarkerSave = this.perfMarker.createChild('Create_Ad_Save');
      this.perfMarkerSave.willInit();
    }
    let saveAdPromise = null;

    // Special case for Responsive ad, since we are consuming existing component for ad creation. Which does not match the structure of the existing views.
    if (this._type === 'Responsive') {
      const adEditorView = this.adTypeViews[this._type];

      saveAdPromise = this.isSaveToServer ?
        adEditorView.saveAdAsync((data, adId, type) => this.handleSave(data, adId, type)) :
        adEditorView.saveToClient((data, adId, type) => this.handleSave(data, adId, type));
    } else {
      saveAdPromise = Promise.resolve(this.isSaveToServer ? this.saveToServer() : this.saveToClient());
    }

    saveAdPromise.then((success = false) => {
      if (success) {
        this.closingAfterSave = true;
        this.trigger('close');
        if (this.perfMarkerSave) {
          this.perfMarkerSave.done();
        }
        if (this._type === adTypeEnum.responsiveSearch && this.adViewOption.inlineSuggestionsEnabled) {
          this.logCopilotRSAAssetSuggestionAdoption();
          if (this.isSaveToServer) {
            this.logRSAAssetSuggestionAdoption();
          }
        }
        this.logActivity('ad editor save success');

        if (this.isOpenCreatePanel) {
          this.logDeliveryStatusRecommendationAdoption();
        }

      } else {
        const $errors = this.$el.closest('.panel-body-ad').find('[role=alert]:visible').not('[aria-hidden=true]');

        if ($errors.exists()) {
          $errors[0].scrollIntoView({ block: 'center' });
        }
        this.logActivity('ad editor save failed');
      }
      // Trigger survey in ads page when RSA editor is saved
      if (this._type === adTypeEnum.responsiveSearch && window.survey && window.survey.surveyManager) {
        window.survey.surveyManager.trigger();
      }
    });
  }

  saveAndCreateAnother() {
    this.logActivity('ad editor click save and create another');
    this.trigger('saving');

    // Special case for Responsive ad, since we are consuming existing component for ad creation. Which does not match the structure of the existing views.
    if (this._type === 'Responsive') {
      const adEditorView = this.adTypeViews[this._type];
      const saveAndCreateAnotherFunc = this.isSaveToServer ? 'saveAndCreateAnotherAsync' : 'saveToClientAndCreateAnother';

      adEditorView[saveAndCreateAnotherFunc]((data, adId, type) => {
        this.handleSave(data, adId, type);
        if (this.isOpenCreatePanel) {
          this.logDeliveryStatusRecommendationAdoption();
        }
        this.resetViewToCreateAnother();
      });

      return;
    }

    Promise.resolve(this.isSaveToServer ? this.saveToServer() : this.saveToClient())
      .then((success = false) => {
        if (success) {
          if (this._type === adTypeEnum.responsiveSearch && this.adViewOption.inlineSuggestionsEnabled) {
            this.logCopilotRSAAssetSuggestionAdoption();
            if (this.isSaveToServer) {
              this.logRSAAssetSuggestionAdoption();
            }
          }
          if (this.isOpenCreatePanel) {
            this.logDeliveryStatusRecommendationAdoption();
          }
          this.resetViewToCreateAnother();
        }
      });
  }

  resetViewToCreateAnother() {
    //this prop is used in save function to indicate edit mode
    this.editMode = false;
    //shouldn't assign empty object to model, hasChange function needs it.
    this.model = _.omit(this.model, 'Id');
    this.model.isSaved = false;
    //hide appeal panel
    this.viewModel.errors.isAppealable(false);
    //reset editMode in subview
    _.each(this.adTypeViews, (subView) => {
      if (_.isFunction(subView.resetEditMode)) {
        subView.resetEditMode(false);
      }
    });

    this.logActivity('ad editor save and create another successful');
    this.closingAfterSave = false;
  }

  switchBackToSTA() {
    this.viewModel.Type(adTypeEnum.text); // eslint-disable-line
  }

  switchBackToEXTA() {
    this.viewModel.Type(adTypeEnum.expandedText); // eslint-disable-line
  }

  validate(type) {
    // Responsive uses an existing componenet which already takes care of the validation before saving
    let isValid = type === 'Responsive' ? true : this.adTypeViews[type].validate();

    if (this.viewModel.errors.isAppealable()) {
      isValid = this.editorialAppeal.validate() && isValid;
    }

    return isValid;
  }

  saveToServer() {
    const type = this._type;

    if (!this.validate(type)) {
      this.logActivity('Validated ad failed and will not save this ad to server');
      return false;
    }

    this.clearApiErrors();

    const params = this.adTypeViews[type].toObject();
    const campaignId = Number(this.viewModel.scope().campaignId);
    const adGroupId = Number(this.viewModel.scope().adGroupId);

    // Path1, Path2, TextPart2 and TitlePart3 allow space, but doesn't allow ONLY space
    if (params.Path1 && params.Path1.trim() === '') {
      params.Path1 = '';
    }
    if (params.Path2 && params.Path2.trim() === '') {
      params.Path2 = '';
    }
    if (params.TextPart2 && params.TextPart2.trim() === '') {
      params.TextPart2 = '';
    }
    if (params.TitlePart3 && params.TitlePart3.trim() === '') {
      params.TitlePart3 = '';
    }

    const scope = this.showInline ? {
      entitySet: edmCampaign.currentAccount.Campaigns.$withKey(campaignId).AdGroups.$withKey(adGroupId).Ads,
      cacheResponse: false,
      scenario: 'ads-grid',
    } : { adapter: 'bulk', cacheResponse: false };

    _.extend(params, {
      Campaign: { Id: campaignId },
      AdGroup: { Id: adGroupId },
      Type: type,
    });

    // Create New if it's migrating to EXTA from STA
    if (this.editMode && !(this.isMigratingToEXTA && type === adTypeEnum.expandedText)) {
      params.Id = this.model.Id;
    }

    if (this.viewModel.errors.isAppealable() && this.editorialAppeal.ko_model.provideJustification()) {
      _.extend(params, this.editorialAppeal.toObject());
    }

    //In new campaign creation, if user didn't make any change, show alert message.
    if (!this.hasChange(params, type) && !this.showInline) {
      this.viewModel.errors([i18n.get('Ad_Edit_NoChange_AlertMessage')]);
      return false;
    }

    let cachedSavedresult;

    return jsdata[adTypeSchema[type]]
      .create(params, scope)
      .then(({ value, Id }) => {
        this.logActivity(JSON.stringify({
          value,
          Id,
          showInline: this.showInline,
        }), 'save ad to server succeeded with suggestion');

        let adId = this.showInline ? value : Id;

        // MT could return adId as 0, in case of this situaion, we don't update viewmodel adId
        if (adId === 0) {
          adId = this.model.Id;
        }

        return this.handleSave(params, adId, type);
      })
      .catch(({ entity: { Id } = {}, errors } = {}) => {
        if (this._type === adTypeEnum.responsiveSearch && this.adViewOption.inlineSuggestionsEnabled) {
          this.logActivity(JSON.stringify({
            Id,
            showInline: this.showInline,
          }), 'save ad to server failed with suggestion');
        }

        if ((_.isEmpty(this.model) || !this.model.isSaved) && Id) {
          //if the errors are editorial appealable errors, bulk API will return Id back, we'll consider the ad is saved successfully
          return this.handleSave(params, Id, type);
        }

        _.chain(errors).map((error) => error.Error || error.Code).uniq().each((error) => {
          this.logActivity(error, 'ad creation api error');
        });

        return this.handleApiErrors(this.showInline ? getODataErrors(errors, permissions) : getBulkApiErrors(errors, undefined, permissions));
      })
      .then((success = false) => {
        cachedSavedresult = success;

        // saveImageExtensionsToServer is non-blocking, but we need to ensure that promise is fulfilled before closing editor
        if (success && this.adTypeViews[type].enableRSAExpansion) {
          return this.adTypeViews[type].saveImageExtensionsToServer({
            adId: this.model.Id,
            perfMarker: this.perfMarkerSave,
          });
        }

        return true;
      })
      .then(() => {
        return cachedSavedresult;
      })
      .finally(withUiBlock(this.$el));
  }

  handleSave(data, adId, type) {
    const logging = `${type}Ad${this.showInline ? ' under ads tab' : ''}`;

    const params = _.pick(data, _.negate(_.isNull));

    params.Id = adId;
    params.isSaved = this.isSaveToServer;

    if (_.isEmpty(this.model) || !this.model.Id || (this.isMigratingToEXTA && this.model.Id !== adId)) {
      // create a new ad, trigger 'created' event
      this.trigger('created', params);
      this.adTypeViews[type].trigger('created');
      legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, `create${logging}`, 1);
      this.logActivity(1, `createAd: ${type}`);
    } else if (this.model.isSaved) {
      // update the ad
      this.trigger('updated', params);
      legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, `update${logging}`, 1);
      this.logActivity(1, `updateAd: ${type}`);
    } else {
      // create the copied ad, trigger 'updated' event
      this.trigger('updated', params);
      legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, `create${logging}`, 1);
      this.logActivity(1, `createAd: ${type}`);
    }

    if (this.isMigratingToEXTA) {
      let message = this.model.Id === adId ? 'staEdited' : 'extaCreated';

      legacyInstru.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'crud-ad/view/adEditor', `extaMigration-${message}`);
    }

    this.model = params;

    this.activity.stop();
    return true;
  }

  prepareErrorMessage(errors) {
    const type = this._type;

    _.each(errors, (err) => {
      if (_.has(err, 'property') && _.has(this.adTypeViews[type].viewModel, err.property) && _.contains(lengthExceededErrorCodes, err.code)) {
        const length = this.adTypeViews[type].viewModel[err.property].maxLength();

        if (err.message && (err.message.indexOf('{1}') > -1)) {
          err.message = err.message.replace('{1}', length);
        }
      }
    });
  }

  saveToClient() {
    const type = this._type;

    if (!this.adTypeViews[type].validate()) {
      return false;
    }

    const model = this.adTypeViews[type].toObject();

    model.Type = this._type;

    if (_.isEmpty(this.model) || !this.model.Id) {
      model.Id = uuid.v4();
      this.trigger('created', model);
      this.adTypeViews[type].trigger('created');
    } else {
      model.isSaved = this.model.isSaved;
      model.Id = this.model.Id;
      this.trigger('updated', model);
    }

    this.lastClientModelId = model.Id;

    return true;
  }

  hasChange(params, type) {
    let current = _.pick(params, schemaMapper[type]());
    let original = _.pick(this.model, schemaMapper[type]());

    current = _.pick(current, _.negate(_.isEmpty));
    original = _.pick(original, _.negate(_.isEmpty));

    return !_.isEqual(_.omit(current, 'Id'), _.omit(original, 'Id'));
  }

  handleApiErrors(errors) {
    const type = this._type;

    this.prepareErrorMessage(errors);

    if (type !== 'Responsive') {
      // MMA will handle in its view
      this.adTypeViews[type].handleApiErrors(errors);
      this.viewModel.errors(this.adTypeViews[type].viewModel.errors());
    }

    const appealableErrors = getAppealableErrors(errors);

    this.viewModel.errors.isAppealable(appealableErrors.isAppealable);
    if (this.viewModel.errors.isAppealable()) {
      this.editorialAppeal.setRejectedInfos(appealableErrors);
    }

    return false;
  }

  clearApiErrors() {
    const type = this._type;

    this.adTypeViews[type].clearApiErrors();

    this.viewModel.errors([]);
  }

  cancel() {
    this.trigger('canceling');
    this.trigger('cancel');
  }

  triggerClose() {
    this.trigger('close');
  }

  get _type() {
    return this.viewModel.Type(); // eslint-disable-line
  }

  mapSTAToEXTA(model) {
    const paths = getPath1AndPath2(model.DisplayUrl);

    return {
      DisplayUrl: '',
      FinalUrls: _.isEmpty(model.FinalUrls) ? [(/^https?:\/\//i).test(model.DestinationUrl) ? model.DestinationUrl : `https://${model.DestinationUrl}`] : model.FinalUrls,
      MobileFinalUrls: model.MobileFinalUrls,
      NativePreference: model.NativePreference,
      Path1: paths.path1,
      Path2: paths.path2,
      Text: model.Text,
      TitlePart1: model.Title,
      TitlePart2: '',
      TrackingUrlTemplate: model.TrackingUrlTemplate,
      Type: adTypeEnum.expandedText,
      UrlCustomParameters: model.UrlCustomParameters,
    };
  }
}
